import { render, staticRenderFns } from "./FourthQuestion.vue?vue&type=template&id=037a19d1&"
import script from "./FourthQuestion.vue?vue&type=script&lang=js&"
export * from "./FourthQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FourthQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports